/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener('click', function(e) {
  const link = e.target.closest('label[for="agree"] a');
  if (!link) return;

  const cb = document.querySelector('#effectiveAppsAgreeCB');
  if (!cb) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  cb.checked = !cb.checked;
  cb.dispatchEvent(new Event('change', { bubbles: true }));
}, true);

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
